import moment from "moment";

export const CUSTOMER_EDIT_CUTOFF_HOURS = 24;
export const CUSTOMER_CANCEL_CUTOFF_HOURS = 5;
export const ORDER_SUPPORT_PHONE = "(646) 535-4875";

export const ORDER_EDIT_WINDOW_MESSAGE =
  `Online order edits close ${CUSTOMER_EDIT_CUTOFF_HOURS} hours before delivery. Please call or text us at ${ORDER_SUPPORT_PHONE} for help.`;
export const ORDER_CANCEL_WINDOW_MESSAGE =
  `Online order cancellations close ${CUSTOMER_CANCEL_CUTOFF_HOURS} hours before delivery. Please call or text us at ${ORDER_SUPPORT_PHONE} for help.`;
export const ORDER_EDIT_CANCEL_WINDOW_MESSAGE =
  `Online order edits and cancellations are closed. Please call or text us at ${ORDER_SUPPORT_PHONE} for help.`;

export function getOrderDeliveryMoment(order) {
  const delivery = moment(order?.deliveryDate);
  if (!delivery.isValid()) {
    return null;
  }

  if (order?.deliveryTime) {
    const parsedTime = moment(
      order.deliveryTime,
      ["h:mm A", "hh:mm A", "H:mm", "HH:mm"],
      true,
    );
    if (parsedTime.isValid()) {
      delivery.set({
        hour: parsedTime.hour(),
        minute: parsedTime.minute(),
        second: 0,
        millisecond: 0,
      });
    }
  }

  return delivery;
}

export function getCustomerOrderActionWindow(order, now = moment()) {
  const delivery = getOrderDeliveryMoment(order);
  const currentTime = moment(now);
  const hoursUntilDelivery = delivery
    ? delivery.diff(currentTime, "minutes", true) / 60
    : null;

  return {
    hoursUntilDelivery,
    canEdit:
      hoursUntilDelivery !== null &&
      hoursUntilDelivery >= CUSTOMER_EDIT_CUTOFF_HOURS,
    canCancel:
      hoursUntilDelivery !== null &&
      hoursUntilDelivery >= CUSTOMER_CANCEL_CUTOFF_HOURS,
  };
}

export function getOrderActionHelpMessage({
  editBlocked,
  cancelBlocked,
}) {
  if (editBlocked && cancelBlocked) {
    return ORDER_EDIT_CANCEL_WINDOW_MESSAGE;
  }
  if (cancelBlocked) {
    return ORDER_CANCEL_WINDOW_MESSAGE;
  }
  if (editBlocked) {
    return ORDER_EDIT_WINDOW_MESSAGE;
  }
  return null;
}
